module.exports = __webpack_public_path__ + "my-team_teal.cd58c40a3ac2b701b5b9.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/my-team_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/my-team_teal.svg
// module chunks = styles